/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  ProductSelectionViewModel,
  Result,
  ResultOfProductSelectionViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ProductSelectionViewModelFromJSON,
    ProductSelectionViewModelToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfProductSelectionViewModelFromJSON,
    ResultOfProductSelectionViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface ProductSelectionsFetchRequest {
    proposalId: number;
}

export interface ProductSelectionsSubmitRequest {
    productSelection: ProductSelectionViewModel;
}

/**
 * 
 */
export class ProductSelectionsApi extends runtime.BaseAPI {

    /**
     * Get product details
     */
    async productSelectionsFetchRaw(requestParameters: ProductSelectionsFetchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfProductSelectionViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling productSelectionsFetch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/product-selection/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfProductSelectionViewModelFromJSON(jsonValue));
    }

    /**
     * Get product details
     */
    async productSelectionsFetch(requestParameters: ProductSelectionsFetchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfProductSelectionViewModel> {
        const response = await this.productSelectionsFetchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save product details
     */
    async productSelectionsSubmitRaw(requestParameters: ProductSelectionsSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.productSelection === null || requestParameters.productSelection === undefined) {
            throw new runtime.RequiredError('productSelection','Required parameter requestParameters.productSelection was null or undefined when calling productSelectionsSubmit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/product-selection`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductSelectionViewModelToJSON(requestParameters.productSelection),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Save product details
     */
    async productSelectionsSubmit(requestParameters: ProductSelectionsSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.productSelectionsSubmitRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
